// extracted by mini-css-extract-plugin
export default {"form":"stack-page_form__Y4AwW","result":"stack-page_result__yc6yc"};